module.exports = "/images/Logo-Text-Below.svg?f0941bee7d3b69e78a42ca5d6d592b1c";